export default {"src":"/_next/static/media/coffee_maker.2788d284.svg","height":100,"width":100};